<script setup>
import MaintenanceInterventionCompletion from './MaintenanceInterventionCompletion.vue';

defineProps({
    extension: { type: Object, required: true },
    recordId: { type: [String, Number], default: null },
    submitAction: { type: [Function, Object], default: null },
});
</script>

<template>
    <MaintenanceInterventionCompletion v-if="extension.showCompletion.value"
        :intervention-id="recordId" :scope="extension.scope"
        :offline-enabled="extension.completionOfflineEnabled.value" @completed="extension.onCompleted" />
    <section v-if="extension.offlineMode" class="mb-4 space-y-3 bg-[#F1F0EC] px-3 py-3 md:px-4">
        <div class="flex flex-wrap items-center justify-between gap-3 text-sm">
            <span class="inline-flex items-center gap-2 font-semibold">
                <span class="h-2.5 w-2.5 rounded-full"
                    :class="extension.offline.online.value ? 'bg-[#35705A]' : 'bg-[#A83B32]'" />
                {{ extension.statusLabel.value }}
            </span>
            <div v-if="extension.offline.pending.value" class="flex gap-2">
                <button type="button" class="min-h-11 border border-[#312D32]/25 px-3 text-xs font-semibold uppercase"
                    :disabled="extension.offline.syncing.value || !extension.offline.online.value"
                    @click="extension.retry(submitAction)">Riprova</button>
                <button type="button" class="min-h-11 px-3 text-xs font-semibold uppercase text-[#A83B32]"
                    :disabled="extension.offline.syncing.value" @click="extension.discard">Scarta</button>
            </div>
        </div>
        <p v-if="extension.offline.lastError.value?.message" class="text-sm font-semibold text-[#A83B32]">
            {{ extension.offline.lastError.value.message }}
        </p>
    </section>
</template>